import { useState } from "react";

function usePagination(data, itemsPerPage, initialPage = 1) {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const maxPage = Math.ceil(data.length / itemsPerPage);

  function currentData() {
    let begin

    if (initialPage === 0) {
      begin = ((currentPage + 1) - 1) * itemsPerPage;
    } else {
      begin = (currentPage - 1) * itemsPerPage;
    }

    const end = begin + itemsPerPage;
    return data.slice(begin, end);
  }

  function next() {
    setCurrentPage((currentPage) => Math.min(currentPage + 1, maxPage));
  }

  function prev() {
    setCurrentPage((currentPage) => Math.max(currentPage - 1, initialPage));
  }

  function jump(page) {
    const pageNumber = Math.max(initialPage, page);
    setCurrentPage((currentPage) => Math.min(pageNumber, maxPage));
  }

  return {
    next,
    prev,
    jump,
    currentData,
    currentPage,
    maxPage,
  };
}

export default usePagination;
